import React from 'react';
import { Badge } from '@emorg-prd/standard-react';
import './POROperationBadge.css'

interface PORTypeBadgeProps {
	children: string;
}

const PORTypeBadge = ({ children }: PORTypeBadgeProps) => {
	const getType = (): | "em-c-badge--caution" | undefined => {
		switch (children) {
			case 'Permanent':
				return undefined;
			case 'Temporary':
				return "em-c-badge--caution";
			default:
				return undefined;
		}
	};

	const getText = () => {
		switch (children) {
			case 'Temporary':
				return 'Temp';
			case 'Permanent':
				return 'Perm';
			default:
				return children;
		}
	};
		
	const getOptionalClass = () => {
		if (children !== 'Permanent' && children !== 'Temporary') return 'operation-badge--neutral';
		return '';
	};

	return (
		<Badge type={getType()} optionalClass={`em-u-max-width-10 operation-badge ${getOptionalClass()}`} text={getText()} />
	);
};

export default PORTypeBadge;